module.exports = __webpack_public_path__ + "img/MNEX32-default-back.61c4a558.jpg";